(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozair-compare"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sa-pillow-compare')) {
  customElements.define('sa-pillow-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('.sa-compare__content');
      this.fallback = this.querySelector('.sa-compare__fallback');
      if (!this.dialog || !this.content || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('.sa-compare__dialog-body').append(this.content);
      this.querySelectorAll('[data-sa-variant]').forEach(select => { select.disabled = false; });
      this.querySelector('[data-compare-toolbar]').hidden = false;
      this.setAttribute('data-ready', '');
      this.filter = 'all';
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-sa-compare]');
        if (!trigger) return;
        const target = trigger.dataset.saCompare;
        if (target && target !== this.dataset.sectionId && target !== this.id) return;
        if (!target && document.querySelector('sa-pillow-compare') !== this) return;
        event.preventDefault();
        if (this.dialog.open) return;
        const currentId = trigger.dataset.saVariant || new URL(window.location.href).searchParams.get('variant');
        if (currentId) this.querySelectorAll('[data-sa-variant]').forEach(select => {
          if (Array.from(select.options).some(option => option.value === currentId)) {
            select.value = currentId;
            this.updateVariant(select, false);
          }
        });
        this.returnFocus = trigger;
        this.dialog.showModal();
        document.body.classList.add('sa-compare-open');
      }, options);
      this.querySelector('[data-sa-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('sa-compare-open');
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }, options);
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-sa-variant]');
        if (select) this.updateVariant(select, true);
      }, options);
      this.querySelectorAll('[data-compare-filter]').forEach(button => button.addEventListener('click', () => {
        this.filter = button.dataset.compareFilter;
        this.applyFilter();
      }, options));
      this.applyFilter();
    }
    updateVariant(select, announce) {
      const option = select.selectedOptions[0];
      if (!option) return;
      const kind = select.dataset.saVariant;
      const image = this.querySelector('[data-sa-product="' + kind + '"] img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = option.dataset.image;
        image.alt = option.dataset.alt;
      }
      this.querySelector('[data-sa-price="' + kind + '"]').textContent = option.dataset.price;
      this.querySelector('[data-sa-product-link="' + kind + '"]').href = option.dataset.url;
      const question = this.querySelector('[data-sa-question="' + kind + '"]');
      if (question) {
        const url = new URL(option.dataset.url, window.location.origin);
        url.searchParams.set('availability', '1');
        question.href = url.pathname + url.search;
        question.hidden = option.dataset.available === 'true';
      }
      const status = this.querySelector('[data-sa-status="' + kind + '"]');
      status.textContent = option.dataset.available === 'true' ? status.dataset.availableText : status.dataset.unavailableText;
      if (announce) this.querySelector('.sa-compare__selection-status').textContent = option.textContent.trim() + ' · ' + option.dataset.price + ' · ' + status.textContent;
      this.applyFilter();
    }
    applyFilter() {
      this.querySelectorAll('[data-compare-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.compareFilter === this.filter)));
      this.querySelectorAll('[data-compare-row]').forEach(row => {
        const cells = Array.from(row.querySelectorAll('td')).map(cell => cell.textContent.trim().replace(/\s+/g, ' '));
        row.hidden = this.filter === 'different' && cells.length === 2 && cells[0] === cells[1];
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('sa-compare-open');
      this.controller = null;
      if (this.fallback && this.content) this.fallback.append(this.content);
      this.querySelectorAll('[data-sa-variant]').forEach(select => { select.disabled = true; });
      const toolbar = this.querySelector('[data-compare-toolbar]');
      if (toolbar) toolbar.hidden = true;
      this.querySelectorAll('[data-compare-row]').forEach(row => { row.hidden = false; });
      this.removeAttribute('data-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozair-contact"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('snoozair-contact')) {
  customElements.define('snoozair-contact', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected || this.dataset.responseFocused) return;
        const response = this.querySelector('[data-contact-response]');
        if (!response) return;
        this.dataset.responseFocused = 'true';
        if (document.activeElement !== response) response.focus();
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozair-explorer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sa-product-explorer')) {
customElements.define('sa-product-explorer', class extends HTMLElement {
connectedCallback() {
if (this.events) return;
this.events = new AbortController();
this.panels = [...this.querySelectorAll('[data-model-panel]')];
this.tabs = [...this.querySelectorAll('[data-model-tab]')];
if (!this.panels.length) return;
const opts = { signal: this.events.signal };
this.tablist = this.querySelector('[data-model-tabs]');
this.status = this.querySelector('[data-explorer-status]');
this.zoomDialog = this.querySelector('[data-zoom-dialog]');
this.zoomPicture = this.querySelector('[data-zoom-picture]');
this.zoomStage = this.querySelector('[data-zoom-stage]');
this.zoomStatus = this.querySelector('[data-zoom-status]');
this.zoomCapable = typeof this.zoomDialog?.showModal === 'function';
if (this.zoomCapable) {
this.zoomDialog.addEventListener('close', () => {
if (!this.zoomDialog.open) this.finishZoom(true);
}, opts);
this.zoomDialog.addEventListener('pointerdown', event => {
this.zoomBackdropStart = event.target === this.zoomDialog && this.outsideZoom(event);
}, opts);
this.zoomDialog.addEventListener('click', event => {
if (this.zoomBackdropStart && event.target === this.zoomDialog && this.outsideZoom(event)) this.zoomDialog.close();
this.zoomBackdropStart = false;
}, opts);
}
this.tablist.setAttribute('role', 'tablist');
this.tablist.hidden = this.tabs.length < 2;
this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
this.panels.forEach(panel => {
panel.setAttribute('role', 'tabpanel');
panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.modelTab === panel.dataset.modelPanel).id);
const stage = panel.querySelector('[data-image-stage]');
stage.tabIndex = 0;
panel.querySelectorAll('[data-slide] img').forEach(image => {
image.addEventListener('load', () => this.syncImage(panel), opts);
image.addEventListener('error', () => this.syncImage(panel), opts);
});
const count = panel.querySelectorAll('[data-slide]').length;
panel.querySelector('[data-gallery-controls]').hidden = count < 2;
const zoomTrigger = panel.querySelector('[data-image-zoom]');
if (zoomTrigger) zoomTrigger.hidden = !this.zoomCapable || count === 0;
const thumbs = panel.querySelector('[data-thumbnails]');
if (thumbs) thumbs.hidden = false;
const select = panel.querySelector('[data-variant-select]');
if (select) {
select.disabled = false;
panel.querySelector('[data-variant-picker]').hidden = false;
panel.querySelector('[data-variant-fallback]').hidden = true;
this.applyVariant(panel, true, false);
} else this.showImage(panel, 0, false);
stage.addEventListener('pointerdown', event => {
if (!event.isPrimary || event.target.closest('button')) { this.gesture = null; return; }
if (event.pointerType === 'touch') this.gesture = { stage, x: event.clientX, y: event.clientY, at: performance.now() };
}, opts);
stage.addEventListener('pointerup', event => {
const gesture = this.gesture;
this.gesture = null;
if (!gesture || gesture.stage !== stage) return;
const x = event.clientX - gesture.x;
const y = event.clientY - gesture.y;
if (Math.abs(x) > 48 && Math.abs(x) > Math.abs(y) * 1.4 && performance.now() - gesture.at < 900) this.moveImage(panel, x < 0 ? 1 : -1);
}, opts);
stage.addEventListener('pointercancel', () => { this.gesture = null; }, opts);
});
this.addEventListener('click', event => {
if (this.zoomDialog?.contains(event.target)) {
if (event.target.closest('[data-zoom-close]')) this.zoomDialog.close();
const step = event.target.closest('[data-zoom-step]');
if (step && this.zoomDialog.open && this.zoomPanel) this.moveImage(this.zoomPanel, Number(step.dataset.zoomStep));
return;
}
const tab = event.target.closest('[data-model-tab]');
if (tab && this.contains(tab)) { this.showModel(tab.dataset.modelTab, true); return; }
const panel = event.target.closest('[data-model-panel]');
if (!panel || !this.contains(panel)) return;
const zoomTrigger = event.target.closest('[data-image-zoom]');
if (zoomTrigger) { this.openZoom(panel, zoomTrigger); return; }
const step = event.target.closest('[data-image-step]');
const thumb = event.target.closest('[data-thumbnail]');
if (step) this.moveImage(panel, Number(step.dataset.imageStep));
if (thumb) this.showImage(panel, Number(thumb.dataset.thumbnail), true);
}, opts);
this.addEventListener('change', event => {
if (event.target.matches('[data-variant-select]')) this.applyVariant(event.target.closest('[data-model-panel]'), true, true);
}, opts);
this.addEventListener('keydown', event => {
if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
if (this.zoomDialog?.open) {
if (this.zoomPanel && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
event.preventDefault();
if (event.key === 'Home' || event.key === 'End') this.showImage(this.zoomPanel, event.key === 'Home' ? 0 : this.zoomPanel.querySelectorAll('[data-slide]').length - 1, true);
else this.moveImage(this.zoomPanel, event.key === 'ArrowRight' ? 1 : -1);
}
return;
}
const tab = event.target.closest('[data-model-tab]');
if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
event.preventDefault();
const current = this.tabs.indexOf(tab);
const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
this.showModel(this.tabs[index].dataset.modelTab, true);
this.tabs[index].focus();
} else if (event.target.matches('[data-image-stage]') && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
event.preventDefault();
const panel = event.target.closest('[data-model-panel]');
if (event.key === 'Home' || event.key === 'End') this.showImage(panel, event.key === 'Home' ? 0 : panel.querySelectorAll('[data-slide]').length - 1, true);
else this.moveImage(panel, event.key === 'ArrowRight' ? 1 : -1);
}
}, opts);
this.dataset.ready = '';
this.showModel(this.activeModel || this.panels[0].dataset.modelPanel, false);
if ('IntersectionObserver' in window) {
this.imageObserver = new IntersectionObserver(entries => {
if (entries.some(entry => entry.isIntersecting)) this.warmImages();
}, { rootMargin: '300px 0px', threshold: 0 });
this.imageObserver.observe(this);
}
}
showModel(model, announce) {
const selected = this.panels.find(panel => panel.dataset.modelPanel === model) || this.panels[0];
this.activeModel = selected.dataset.modelPanel;
this.panels.forEach(panel => { panel.hidden = panel !== selected; });
this.tabs.forEach(tab => {
const active = tab.dataset.modelTab === this.activeModel;
tab.setAttribute('aria-selected', String(active));
tab.tabIndex = active ? 0 : -1;
});
if (announce) {
this.warmImages();
this.announceSelection(selected);
}
this.syncImage(selected);
}
applyVariant(panel, changeImage, announce) {
const option = panel.querySelector('[data-variant-select]')?.selectedOptions[0];
if (!option) return;
const available = option.dataset.available === 'true';
panel.querySelector('[data-display-price]').textContent = option.dataset.price;
panel.querySelector('[data-stock]').dataset.available = String(available);
panel.querySelector('[data-stock-text]').textContent = available ? this.dataset.available : this.dataset.unavailable;
panel.querySelector('[data-product-link]').href = option.dataset.url;
panel.querySelector('[data-sa-compare]').dataset.saVariant = option.value;
const inquiry = panel.querySelector('[data-inquiry-link]');
const inquiryUrl = new URL(option.dataset.url, window.location.origin);
inquiryUrl.searchParams.set('availability', '1');
inquiry.href = inquiryUrl.pathname + inquiryUrl.search;
inquiry.hidden = available;
if (changeImage) {
const slides = [...panel.querySelectorAll('[data-slide]')];
const index = slides.findIndex(slide => slide.dataset.imageId === option.dataset.imageId);
this.showImage(panel, index < 0 ? 0 : index, false);
}
if (announce) {
this.warmImages();
this.announceSelection(panel);
}
}
moveImage(panel, direction) {
this.showImage(panel, Number(panel.dataset.imageIndex || 0) + direction, true);
}
showImage(panel, requested, announce) {
const slides = [...panel.querySelectorAll('[data-slide]')];
if (!slides.length) return;
const index = (requested + slides.length) % slides.length;
panel.dataset.imageIndex = index;
slides.forEach((slide, number) => { slide.hidden = number !== index; });
const image = slides[index].querySelector('img');
if (image) image.fetchPriority = 'auto';
this.syncImage(panel);
panel.querySelectorAll('[data-thumbnail]').forEach(thumb => thumb.setAttribute('aria-pressed', String(Number(thumb.dataset.thumbnail) === index)));
const label = this.dataset.imageLabel.replace('[current]', String(index + 1)).replace('[total]', String(slides.length));
panel.querySelector('[data-image-counter]').textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
panel.querySelector('[data-image-stage]').setAttribute('aria-label', `${panel.dataset.modelName} · ${label}`);
if (announce) {
this.warmImages();
const select = panel.querySelector('[data-variant-select]');
const options = select ? [...select.options].filter(option => option.dataset.imageId === slides[index].dataset.imageId) : [];
if (options.length === 1 && select.options.length > 1) {
select.value = options[0].value;
this.applyVariant(panel, false, false);
}
this.announceSelection(panel, label);
}
if (this.zoomDialog?.open && this.zoomPanel === panel) this.drawZoom();
}
openZoom(panel, opener) {
if (!this.zoomCapable || this.zoomDialog.open || !this.isConnected || !panel.querySelector('[data-slide]')) return;
this.zoomPanel = panel;
this.zoomOpener = opener;
this.drawZoom();
this.zoomDialog.showModal();
this.ownerDocument.body.classList.add('sa-explorer-zoom-open');
this.zoomLocked = true;
this.querySelector('[data-zoom-close]').focus({ preventScroll: true });
}
drawZoom() {
const panel = this.zoomPanel;
if (!panel) return;
const slides = [...panel.querySelectorAll('[data-slide]')];
const index = Number(panel.dataset.imageIndex || 0);
const slide = slides[index];
const source = slide?.querySelector('img');
if (!source || !slide.dataset.zoomSrc) return;
this.zoomImageEvents?.abort();
this.zoomImageEvents = new AbortController();
const image = this.ownerDocument.createElement('img');
image.alt = source.alt;
image.draggable = false;
image.decoding = 'async';
image.loading = 'eager';
image.width = Number(source.getAttribute('width')) || 2000;
image.height = Number(source.getAttribute('height')) || 2000;
this.zoomImage = image;
const sync = () => {
if (this.zoomImage === image && this.zoomPanel === panel) this.syncZoomImage();
};
image.addEventListener('load', sync, { signal: this.zoomImageEvents.signal });
image.addEventListener('error', sync, { signal: this.zoomImageEvents.signal });
image.src = slide.dataset.zoomSrc;
this.zoomPicture.replaceChildren(image);
this.zoomDialog.dataset.model = panel.dataset.modelPanel;
this.querySelector('[data-zoom-title]').textContent = panel.dataset.modelName;
const label = this.dataset.imageLabel.replace('[current]', String(index + 1)).replace('[total]', String(slides.length));
const option = panel.querySelector('[data-variant-select]')?.selectedOptions[0]?.textContent.trim();
this.querySelector('[data-zoom-caption]').textContent = [option, label].filter(Boolean).join(' · ');
this.querySelector('[data-zoom-navigation]').hidden = slides.length < 2;
this.syncZoomImage();
}
syncZoomImage() {
const image = this.zoomImage;
if (!image) return;
const state = !image.complete ? 'loading' : image.naturalWidth > 0 ? 'ready' : 'error';
this.zoomStage.dataset.imageState = state;
const message = state === 'loading' ? this.dataset.imageLoading : state === 'error' ? this.dataset.imageError : '';
if (this.zoomStatus.textContent !== message) this.zoomStatus.textContent = message;
this.zoomStatus.hidden = state === 'ready';
}
outsideZoom(event) {
const rect = this.zoomDialog.getBoundingClientRect();
return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
}
finishZoom(restoreFocus) {
if (this.zoomLocked) this.ownerDocument.body.classList.remove('sa-explorer-zoom-open');
this.zoomLocked = false;
this.zoomImageEvents?.abort();
this.zoomImageEvents = null;
this.zoomImage = null;
this.zoomPicture?.replaceChildren();
if (this.zoomStatus) { this.zoomStatus.hidden = true; this.zoomStatus.textContent = ''; }
if (this.zoomStage) delete this.zoomStage.dataset.imageState;
const opener = this.zoomOpener;
this.zoomPanel = null;
this.zoomOpener = null;
this.zoomBackdropStart = false;
if (restoreFocus && this.isConnected && opener?.isConnected) opener.focus({ preventScroll: true });
}
warmImages() {
this.imageObserver?.disconnect();
if (this.imagesWarmed || !this.isConnected) return;
this.imagesWarmed = true;
this.panels.forEach(panel => {
panel.querySelectorAll('[data-slide]').forEach(slide => {
const image = slide.querySelector('img');
if (!image) return;
image.fetchPriority = !panel.hidden && !slide.hidden ? 'auto' : 'low';
image.loading = 'eager';
});
this.syncImage(panel);
});
}
syncImage(panel) {
const stage = panel.querySelector('[data-image-stage]');
const status = panel.querySelector('[data-image-status]');
const image = panel.querySelector('[data-slide]:not([hidden]) img');
if (!image || !status) return;
if (!panel.hidden) image.fetchPriority = 'auto';
const state = !image.complete ? 'loading' : image.naturalWidth > 0 ? 'ready' : 'error';
stage.dataset.imageState = state;
const message = state === 'loading' ? this.dataset.imageLoading : state === 'error' ? this.dataset.imageError : '';
if (status.textContent !== message) status.textContent = message;
status.hidden = state === 'ready';
}
announceSelection(panel, extra = '') {
const option = panel.querySelector('[data-variant-select]')?.selectedOptions[0]?.textContent.trim();
this.status.textContent = [panel.dataset.modelName, option, panel.querySelector('[data-display-price]').textContent.trim(), panel.querySelector('[data-stock-text]').textContent.trim(), extra].filter(Boolean).join(' · ');
}
disconnectedCallback() {
if (this.zoomDialog?.open) this.zoomDialog.close();
this.finishZoom(false);
this.imageObserver?.disconnect();
this.imageObserver = null;
this.imagesWarmed = false;
this.events?.abort();
this.events = null;
this.gesture = null;
this.removeAttribute('data-ready');
if (this.tablist) this.tablist.hidden = true;
this.panels?.forEach(panel => {
panel.hidden = false;
panel.removeAttribute('role');
panel.setAttribute('aria-labelledby', panel.querySelector('h3').id);
panel.querySelectorAll('[data-slide]').forEach(slide => {
slide.hidden = false;
const image = slide.querySelector('img');
if (image) { image.loading = 'lazy'; image.fetchPriority = 'auto'; }
});
const stage = panel.querySelector('[data-image-stage]');
stage.tabIndex = 0;
delete stage.dataset.imageState;
const imageStatus = panel.querySelector('[data-image-status]');
if (imageStatus) { imageStatus.hidden = true; imageStatus.textContent = ''; }
panel.querySelector('[data-gallery-controls]').hidden = true;
const zoomTrigger = panel.querySelector('[data-image-zoom]');
if (zoomTrigger) zoomTrigger.hidden = true;
const thumbs = panel.querySelector('[data-thumbnails]');
if (thumbs) thumbs.hidden = true;
const select = panel.querySelector('[data-variant-select]');
if (select) {
select.disabled = true;
panel.querySelector('[data-variant-picker]').hidden = true;
panel.querySelector('[data-variant-fallback]').hidden = false;
}
});
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozair-help"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sa-travel-help')) {
  customElements.define('sa-travel-help', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (typeof this.dialog?.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input = this.querySelector('[data-help-search]');
      this.answers = Array.from(this.querySelectorAll('[data-help-answer]'));
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-sa-help]');
        if (!trigger || document.querySelector('sa-travel-help') !== this) return;
        event.preventDefault();
        if (this.dialog.open) return;
        this.opener = trigger;
        this.reset();
        this.dialog.showModal();
        document.body.classList.add('sa-help-open');
      }, options);
      this.querySelector('[data-help-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('sa-help-open');
        if (this.afterClose) {
          const action = this.afterClose;
          this.afterClose = null;
          action();
          return;
        }
        if (this.leavingPage) { this.leavingPage = false; return; }
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.querySelector('[data-help-search-form]').addEventListener('submit', event => { event.preventDefault(); this.search(); }, options);
      this.input.addEventListener('input', () => this.search(), options);
      this.querySelector('[data-help-clear]').addEventListener('click', () => { this.reset(); this.input.focus(); }, options);
      this.querySelector('[data-help-reset]').addEventListener('click', () => { this.reset(); this.input.focus(); }, options);
      this.addEventListener('click', event => {
        const contact = event.target.closest('[data-help-contact]');
        if (contact) {
          const destination = new URL(contact.href, window.location.origin);
          const form = document.getElementById('ContactForm');
          if (form && destination.pathname === window.location.pathname) {
            event.preventDefault();
            this.afterClose = () => {
              form.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
              form.querySelector('input:not([type="hidden"]),textarea,button')?.focus({ preventScroll: true });
            };
          } else this.leavingPage = true;
          this.dialog.close();
          return;
        }
        const compare = event.target.closest('[data-help-compare]');
        if (!compare) return;
        const destination = document.querySelector('sa-navigation [data-sa-compare]') || document.querySelector('sa-pillow-compare [data-sa-compare]');
        if (destination) {
          event.preventDefault();
          this.afterClose = () => destination.click();
          this.dialog.close();
        }
      }, options);
    }
    search() {
      const query = this.input.value.trim().toLocaleLowerCase();
      const words = query.split(/\s+/).filter(Boolean);
      let count = 0;
      this.answers.forEach(answer => {
        const text = answer.textContent.toLocaleLowerCase();
        const matches = words.every(word => text.includes(word));
        answer.hidden = !matches;
        if (matches) count += 1;
      });
      this.querySelector('[data-help-clear]').hidden = !query;
      this.querySelector('[data-help-empty]').hidden = count !== 0;
      this.querySelector('[data-help-count]').textContent = query ? this.dataset.countLabel.replace('[count]', count) : '';
    }
    reset() {
      this.input.value = '';
      this.answers.forEach(answer => { answer.open = false; });
      this.search();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.afterClose = null;
      this.leavingPage = false;
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('sa-help-open');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozair-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sa-home')){customElements.define('sa-home',class extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();this.classList.add('is-enhanced');this.addEventListener('click',event=>{const button=event.target.closest('[data-swatch]');if(!button)return;const card=button.closest('[data-card]');card.querySelectorAll('[data-swatch]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));const image=card.querySelector('.sa-card-media img');if(image){image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=button.dataset.alt;}card.querySelector('[data-colour]').textContent=button.dataset.colour;card.querySelector('.sa-price').textContent=button.dataset.price;const stock=card.querySelector('[data-stock]');stock.dataset.available=button.dataset.available;card.querySelector('[data-stock-text]').textContent=button.dataset.available==='true'?this.dataset.availableLabel:this.dataset.unavailableLabel;const inquiry=card.querySelector('[data-card-inquiry]');inquiry.hidden=button.dataset.available==='true';const inquiryUrl=new URL(button.dataset.url,window.location.origin);inquiryUrl.searchParams.set('availability','1');inquiry.href=inquiryUrl.pathname+inquiryUrl.search;card.querySelectorAll('.sa-card-media,.sa-card-link').forEach(link=>link.href=button.dataset.url);},{signal:this.controller.signal});}disconnectedCallback(){this.controller?.abort();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozair-journey"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('snoozair-journey')) {
  customElements.define('snoozair-journey', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (this.events || !this.isConnected) return;
      this.tabs = Array.from(this.querySelectorAll('[data-journey-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-journey-panel]'));
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.tablist = this.querySelector('[data-journey-tabs]');
      this.controls = this.querySelector('[data-journey-controls]');
      this.status = this.querySelector('[data-journey-status]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.panels.forEach(panel => {
        const image = panel.querySelector('.sa-journey__image-wrap img');
        if (!image) return;
        image.addEventListener('load', () => this.syncImage(panel), options);
        image.addEventListener('error', () => this.syncImage(panel), options);
      });
      this.tablist.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(target);
          this.tabs[target].focus({ preventScroll: true });
        }, options);
      });
      this.querySelector('[data-journey-next]').addEventListener('click', () => this.select((this.index + 1) % this.tabs.length), options);
      this.tablist.hidden = false;
      this.controls.hidden = false;
      this.dataset.ready = '';
      this.select(Math.min(this.index || 0, this.tabs.length - 1), false);
      if ('IntersectionObserver' in window) {
        this.preloadObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.warmImages();
        }, { rootMargin: '300px 0px', threshold: 0 });
        this.preloadObserver.observe(this);
      }
    }
    select(index, announce = true) {
      this.index = index;
      this.tabs.forEach((tab, current) => {
        const active = current === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[current].hidden = !active;
      });
      const last = index === this.tabs.length - 1;
      this.querySelector('[data-journey-next-label]').textContent = last ? this.dataset.restartLabel : this.dataset.nextLabel;
      const label = this.dataset.stepLabel.replace('[current]', String(index + 1));
      this.status.textContent = label + ' · ' + this.panels[index].querySelector('h3').textContent.trim();
      if (announce) this.warmImages();
      const image = this.panels[index].querySelector('.sa-journey__image-wrap img');
      if (image) image.fetchPriority = 'auto';
      this.syncImage(this.panels[index]);
      const visual = this.panels[index].querySelector('.sa-journey__image-wrap');
      if (announce && visual?.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.animation?.cancel();
        this.animation = visual.animate([{ opacity: .65, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' });
      }
    }
    warmImages() {
      this.preloadObserver?.disconnect();
      if (this.warmed || !this.isConnected) return;
      this.warmed = true;
      this.panels.forEach((panel, index) => {
        const image = panel.querySelector('.sa-journey__image-wrap img');
        if (!image) return;
        image.fetchPriority = index === this.index ? 'auto' : 'low';
        image.loading = 'eager';
        this.syncImage(panel);
      });
    }
    syncImage(panel) {
      const visual = panel.querySelector('.sa-journey__image-wrap');
      const image = visual?.querySelector('img');
      const status = visual?.querySelector('[data-journey-image-status]');
      if (!image || !status) return;
      const state = !image.complete ? 'loading' : image.naturalWidth > 0 ? 'ready' : 'error';
      visual.dataset.imageState = state;
      const label = state === 'loading' ? this.dataset.loadingLabel : state === 'error' ? this.dataset.errorLabel : '';
      if (status.textContent !== label) status.textContent = label;
      status.hidden = state === 'ready';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.preloadObserver?.disconnect();
      this.preloadObserver = null;
      this.warmed = false;
      this.animation?.cancel();
      this.events?.abort();
      this.events = null;
      this.removeAttribute('data-ready');
      if (this.tablist) { this.tablist.hidden = true; this.tablist.removeAttribute('role'); }
      if (this.controls) this.controls.hidden = true;
      this.panels?.forEach(panel => {
        panel.hidden = false;
        panel.removeAttribute('role');
        panel.removeAttribute('tabindex');
        panel.setAttribute('aria-labelledby', panel.querySelector('h3').id);
        const visual = panel.querySelector('.sa-journey__image-wrap');
        if (visual) {
          delete visual.dataset.imageState;
          visual.querySelector('[data-journey-image-status]').hidden = true;
          const image = visual.querySelector('img');
          image.loading = 'lazy';
          image.fetchPriority = 'auto';
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozair-navigation"]) return;
  try {
    
if (!customElements.get('sa-navigation')) {
  customElements.define('sa-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.onReady = () => this.observeSections();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true, signal: this.controller.signal });
      else this.observeSections();
      document.addEventListener('shopify:section:load', this.onReady, { signal: this.controller.signal });
    }
    observeSections() {
      this.observer?.disconnect();
      const links = Array.from(this.querySelectorAll('[data-nav-section]'));
      if (this.dataset.productPage === 'true') {
        links[0]?.setAttribute('aria-current', 'page');
        return;
      }
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const link = links.find(item => item.dataset.navSection === entry.target.id);
          if (!link) return;
          if (entry.isIntersecting) {
            links.forEach(item => item.removeAttribute('aria-current'));
            link.setAttribute('aria-current', 'location');
          } else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-100px 0px -45% 0px', threshold: 0 });
      links.forEach(link => {
        const section = document.getElementById(link.dataset.navSection);
        if (section) this.observer.observe(section);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozair-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('snoozair-story-explorer')) {
  customElements.define('snoozair-story-explorer', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (this.events || !this.isConnected) return;
      this.stage = this.querySelector('[data-story-stage]');
      this.picture = this.querySelector('[data-story-picture]');
      this.dialog = this.querySelector('[data-story-dialog]');
      this.thumbs = Array.from(this.querySelectorAll('[data-story-thumb]'));
      if (!this.stage || !this.picture || !this.dialog) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.index = Math.max(0, this.thumbs.findIndex(thumb => thumb.getAttribute('aria-current') === 'true'));
      this.thumbs.forEach((thumb, index) => {
        thumb.setAttribute('role', 'button');
        thumb.setAttribute('aria-pressed', String(index === this.index));
        thumb.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.select(index);
        }, { signal });
      });
      this.querySelectorAll('[data-story-prev]').forEach(button => button.addEventListener('click', () => this.select(this.index - 1), { signal }));
      this.querySelectorAll('[data-story-next]').forEach(button => button.addEventListener('click', () => this.select(this.index + 1), { signal }));
      this.querySelectorAll('[data-story-controls]').forEach(controls => { controls.hidden = false; });
      this.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const target = event.target.closest('a, button');
        if (event.key === ' ' && target?.getAttribute('role') === 'button') {
          event.preventDefault();
          target.click();
          return;
        }
        if (!this.thumbs.length || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        if (!this.dialog.open && !target?.matches('[data-story-stage], [data-story-thumb], [data-story-prev], [data-story-next]')) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.thumbs.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.select(index);
        if (target?.matches('[data-story-thumb]')) this.thumbs[this.index].focus({ preventScroll: true });
      }, { signal });
      if (typeof this.dialog.showModal === 'function') {
        this.stage.setAttribute('role', 'button');
        this.stage.setAttribute('aria-haspopup', 'dialog');
        this.stage.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (this.dialog.open) return;
          this.opener = this.stage;
          this.drawZoom();
          this.dialog.showModal();
          this.bodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.scrollLocked = true;
        }, { signal });
        this.querySelector('[data-story-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          this.unlockScroll();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, { signal });
      }
    }
    counter() {
      return this.dataset.counterFormat.replace('__current__', String(this.index + 1)).replace('__total__', String(this.thumbs.length || 1));
    }
    select(index) {
      if (!this.thumbs.length) return;
      this.index = (index + this.thumbs.length) % this.thumbs.length;
      const thumb = this.thumbs[this.index];
      const image = thumb.querySelector('template').content.querySelector('img').cloneNode(true);
      image.loading = 'eager';
      this.picture.replaceChildren(image);
      this.stage.href = thumb.href;
      this.thumbs.forEach((item, current) => {
        item.setAttribute('aria-pressed', String(current === this.index));
        if (current === this.index) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      this.querySelector('[data-story-counter]').textContent = this.counter();
      if (this.dialog.open) this.drawZoom();
    }
    drawZoom() {
      const image = this.picture.querySelector('img').cloneNode(true);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = this.stage.href;
      image.loading = 'eager';
      this.querySelector('[data-story-dialog-image]').replaceChildren(image);
      this.querySelector('[data-story-dialog-counter]').textContent = this.counter();
    }
    unlockScroll() {
      if (!this.scrollLocked) return;
      document.body.style.overflow = this.bodyOverflow;
      this.scrollLocked = false;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
      this.events?.abort();
      this.events = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snoozair-product-tools"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('snoozair-product-tools')) {
  class SnoozairProductTools extends HTMLElement {
    connectedCallback() {
      this.onReady = () => this.setup();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      else this.setup();
    }
    setup() {
      if (this.ready || !this.isConnected) return;
      this.ready = true;
      this.events = new AbortController();
      const eventOptions = { signal: this.events.signal };
      this.inquiry = this.querySelector('[data-inquiry]');
      this.productLinks = this.querySelector('[data-product-links]');
      this.copyButton = this.querySelector('[data-copy-link]');
      this.copyStatus = this.querySelector('[data-copy-status]');
      this.content = this.querySelector('[data-sa-content]');
      this.inquiryImage = this.content.querySelector('[data-inquiry-image] img');
      this.dialog = this.querySelector('[data-sa-dialog]');
      this.dock = this.querySelector('[data-sa-dock]');
      this.action = this.querySelector('[data-dock-action]');
      this.variants = JSON.parse(this.querySelector('[data-sa-variants]').textContent);
      this.info = null;
      this.frame = null;
      this.needsSync = false;
      this.schedule = () => this.queueUpdate(true);
      this.scheduleVisibility = () => this.queueUpdate(false);
      this.dockSizeDirty = true;
      this.scheduleDockResize = () => {
        this.dockSizeDirty = true;
        this.scheduleVisibility();
      };
      if ('ResizeObserver' in window) {
        this.dockResizeObserver = new ResizeObserver(() => {
          if (!this.dock.hidden) this.scheduleDockResize();
        });
        this.dockResizeObserver.observe(this.dock);
      }
      if (navigator.clipboard?.writeText) {
        this.copyButton.hidden = false;
        this.copyButton.addEventListener('click', async () => {
          const url = new URL(window.location.pathname, window.location.origin);
          const variantId = this.nativeButton?.closest('form')?.querySelector('input[name="id"]')?.value;
          if (variantId) url.searchParams.set('variant', variantId);
          const signal = this.events.signal;
          try {
            await navigator.clipboard.writeText(url.href);
            if (!signal.aborted) this.setText(this.copyStatus, this.dataset.copiedLabel);
          } catch {
            if (!signal.aborted) this.setText(this.copyStatus, this.dataset.copyError);
          }
        }, eventOptions);
      }
      this.inquiry.querySelector('summary').addEventListener('click', event => {
        if (typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.openInquiry(event.currentTarget);
      }, eventOptions);
      this.querySelector('[data-sa-close]').addEventListener('click', () => this.dialog.close(), eventOptions);
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('sa-inquiry-open');
        this.scheduleVisibility();
        this.restoreInquiryFocus();
      }, eventOptions);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, eventOptions);
      this.action.addEventListener('click', () => {
        if (this.knownUnavailable) { this.openInquiry(this.action); return; }
        const target = this.nativeButton;
        if (!target) return;
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      }, eventOptions);
      this.bindInfo();
      window.addEventListener('resize', this.scheduleDockResize, eventOptions);
      window.addEventListener('scroll', this.scheduleVisibility, { ...eventOptions, passive: true });
      document.addEventListener('focusin', this.scheduleVisibility, eventOptions);
      document.addEventListener('focusout', this.scheduleVisibility, eventOptions);
      window.addEventListener('popstate', this.schedule, eventOptions);
      document.addEventListener('shopify:section:load', this.schedule, eventOptions);
      document.addEventListener('product-info:loaded', this.schedule, eventOptions);
      this.sync();
      this.visibility();
      const landing = new URL(window.location.href);
      if (landing.searchParams.get('availability') === '1') {
        this.openInquiry(this.inquiry.querySelector('summary'));
        landing.searchParams.delete('availability');
        window.history.replaceState(window.history.state, '', landing.pathname + landing.search + landing.hash);
      }
      const response = this.content.querySelector('[data-form-response]');
      if (response) {
        if (typeof this.dialog.showModal === 'function') this.openInquiry(this.inquiry.querySelector('summary'));
        else this.inquiry.open = true;
        response.focus({ preventScroll: true });
      }
    }
    bindInfo() {
      const info = document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('[id^="ProductInfo-"]');
      if (info === this.info) return;
      this.observer?.disconnect();
      this.info?.removeEventListener('change', this.schedule);
      this.info?.removeAttribute('data-sa-known-unavailable');
      this.intersection?.disconnect();
      this.visibilityAnchor = null;
      this.nativeButton = null;
      this.knownUnavailable = false;
      this.info = info;
      if (this.info) {
        const formElement = this.info.querySelector('product-form');
        if (formElement) {
          formElement.insertAdjacentElement('afterend', this.inquiry);
          this.inquiry.insertAdjacentElement('afterend', this.productLinks);
        }
        this.info.addEventListener('change', this.schedule, { signal: this.events.signal });
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'value', 'class', 'aria-disabled'] });
      }
    }
    queueUpdate(sync) {
      this.needsSync = this.needsSync || sync;
      if (this.frame !== null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.needsSync) {
          this.needsSync = false;
          this.sync();
        }
        this.visibility();
      });
    }
    setText(node, text) {
      if (node && node.textContent !== text) node.textContent = text;
    }
    syncNavigation() {
      const gallery = this.info?.querySelector('media-gallery[id]') || document.querySelector('media-gallery[id^="MediaGallery-"]');
      const details = document.querySelector('.sa-story [id^="SaStoryHeading-"]');
      for (const [selector, target] of [['[data-product-photos]', gallery], ['[data-product-details]', details]]) {
        const link = this.productLinks.querySelector(selector);
        if (!link) continue;
        link.hidden = !target?.id;
        if (target?.id && link.getAttribute('href') !== '#' + target.id) link.setAttribute('href', '#' + target.id);
      }
    }
    sync() {
      this.bindInfo();
      this.syncNavigation();
      if (!this.info) return;
      const button = this.info.querySelector('[id^="ProductSubmitButton-"]');
      const nativeForm = button?.closest('form');
      const selectedId = nativeForm?.querySelector('input[name="id"]')?.value;
      const variant = this.variants.find(item => String(item.id) === String(selectedId));
      this.syncPurchaseState(variant, button);
      const priceRoot = this.info.querySelector('[id^="price-"] .price') || this.info.querySelector('.price');
      const nativePrice = priceRoot?.querySelector(priceRoot.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      const price = nativePrice?.textContent.trim() || variant?.price || '';
      const stock = variant?.available === true ? this.dataset.availableLabel : this.knownUnavailable ? this.dataset.soldLabel : '';
      this.setText(this.querySelector('[data-dock-variant]'), variant?.title ? variant.title + ' · ' : '');
      this.setText(this.querySelector('[data-dock-price]'), price);
      this.setText(this.querySelector('[data-dock-stock]'), stock);
      this.setText(this.content.querySelector('[data-inquiry-price]'), price);
      this.setText(this.content.querySelector('[data-inquiry-stock]'), stock);
      const label = this.knownUnavailable ? this.dataset.inquiryLabel : this.dataset.buyLabel;
      if (this.action.firstChild?.textContent !== label) this.action.firstChild.textContent = label;
      const reference = this.dataset.productTitle + (variant?.title ? ' · ' + variant.title : '');
      const referenceInput = this.content.querySelector('[data-sa-reference]');
      if (referenceInput && referenceInput.value !== reference) referenceInput.value = reference;
      const productURL = this.content.querySelector('input[name="contact[Product URL]"]');
      if (productURL) {
        const cleanURL = new URL(window.location.pathname, window.location.origin);
        if (variant) cleanURL.searchParams.set('variant', String(variant.id));
        if (productURL.value !== cleanURL.href) productURL.value = cleanURL.href;
      }
      this.setText(this.content.querySelector('[data-sa-product]'), reference);
      if (this.inquiryImage && variant?.image) {
        if (this.inquiryImage.getAttribute('src') !== variant.image) {
          this.inquiryImage.removeAttribute('srcset');
          this.inquiryImage.removeAttribute('sizes');
          this.inquiryImage.setAttribute('src', variant.image);
        }
        const alt = variant.imageAlt || reference;
        if (this.inquiryImage.alt !== alt) this.inquiryImage.alt = alt;
      }
      const compare = this.productLinks.querySelector('[data-sa-compare]');
      if (compare && compare.dataset.saVariant !== String(variant?.id || '')) compare.dataset.saVariant = variant ? String(variant.id) : '';
    }
    syncPurchaseState(variant, button) {
      this.nativeButton = button || null;
      this.available = Boolean(button && !button.disabled && button.getAttribute('aria-disabled') !== 'true' && variant?.available);
      this.knownUnavailable = variant?.available === false;
      if (this.info.matches('product-info[id^="MainProduct-"]') && this.knownUnavailable) {
        if (this.info.getAttribute('data-sa-known-unavailable') !== 'true') this.info.setAttribute('data-sa-known-unavailable', 'true');
      } else if (this.info.hasAttribute('data-sa-known-unavailable')) this.info.removeAttribute('data-sa-known-unavailable');
      const blocked = !this.knownUnavailable && !this.available;
      if (this.action.disabled !== blocked) this.action.disabled = blocked;
      const anchor = this.knownUnavailable ? this.inquiry.querySelector('summary') : this.nativeButton;
      if (anchor !== this.visibilityAnchor) {
        this.intersection?.disconnect();
        this.visibilityAnchor = anchor;
        if (anchor && 'IntersectionObserver' in window) {
          this.intersection = new IntersectionObserver(this.scheduleVisibility, { threshold: [0, 1] });
          this.intersection.observe(anchor);
        }
      }
    }
    hasEditableFocus() {
      let active = document.activeElement;
      while (active?.shadowRoot?.activeElement) active = active.shadowRoot.activeElement;
      if (!active || !document.body.contains(active) && !active.getRootNode()?.host) return false;
      if (active.closest?.('dialog:not([open])')) return false;
      if (active.isContentEditable) return true;
      return Boolean(active.matches?.('input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="image"]),textarea,select') && !active.disabled && !active.readOnly);
    }
    setDockVisible(visible) {
      const wasHidden = this.dock.hidden;
      if (wasHidden === visible) this.dock.hidden = !visible;
      if (!visible) {
        if (document.body.classList.contains('sa-product-dock-visible')) document.body.classList.remove('sa-product-dock-visible');
        if (document.body.style.getPropertyValue('--sa-product-dock-height')) document.body.style.removeProperty('--sa-product-dock-height');
        if (document.body.style.getPropertyValue('--sa-product-dock-preview-offset')) document.body.style.removeProperty('--sa-product-dock-preview-offset');
        this.dockSizeDirty = true;
        return;
      }
      if (wasHidden) this.dockSizeDirty = true;
      if (this.dockSizeDirty) {
        const height = Math.ceil(this.dock.getBoundingClientRect().height) + 'px';
        if (document.body.style.getPropertyValue('--sa-product-dock-height') !== height) document.body.style.setProperty('--sa-product-dock-height', height);
        this.dockSizeDirty = false;
      }
      if (!document.body.classList.contains('sa-product-dock-visible')) document.body.classList.add('sa-product-dock-visible');
    }
    visibility() {
      if (!this.visibilityAnchor?.isConnected || this.hasEditableFocus()) { this.setDockVisible(false); return; }
      const rect = this.visibilityAnchor.getBoundingClientRect();
      const visible = rect.bottom <= 0;
      this.setDockVisible(visible);
      if (!visible) return;
      let previewHeight = 0;
      document.querySelectorAll('#PBarNextFrameWrapper,#PBarNextFrame,[id*="preview-bar"],[id*="PreviewBar"]').forEach(element => {
        const preview = element.getBoundingClientRect();
        if (preview.height > 0 && preview.height < 160 && preview.bottom >= window.innerHeight - 2) previewHeight = Math.max(previewHeight, window.innerHeight - preview.top);
      });
      const offset = previewHeight + 'px';
      if (this.dock.style.getPropertyValue('--sa-preview-offset') !== offset) this.dock.style.setProperty('--sa-preview-offset', offset);
      if (document.body.style.getPropertyValue('--sa-product-dock-preview-offset') !== offset) document.body.style.setProperty('--sa-product-dock-preview-offset', offset);
    }
    restoreInquiryFocus() {
      const opener = this.opener;
      cancelAnimationFrame(this.focusReturnFrame);
      this.focusReturnFrame = requestAnimationFrame(() => {
        this.focusReturnFrame = null;
        if (!this.isConnected || this.dialog.open) return;
        const active = document.activeElement;
        if (active && active !== document.body && active !== document.documentElement && active !== opener && !this.dialog.contains(active)) return;
        this.visibility();
        const target = opener?.isConnected && !(opener === this.action && this.dock.hidden) ? opener : this.inquiry.querySelector('summary');
        if (target?.isConnected && target.getClientRects().length) target.focus({ preventScroll: true });
      });
    }
    openInquiry(opener) {
      this.opener = opener;
      this.sync();
      if (typeof this.dialog.showModal !== 'function') {
        this.inquiry.open = true;
        this.inquiry.scrollIntoView({ block: 'center' });
        return;
      }
      this.querySelector('[data-sa-body]').append(this.content);
      if (!this.dialog.open) {
        this.dialog.showModal();
        document.body.classList.add('sa-inquiry-open');
      }
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.onReady);
      this.events?.abort();
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.dockResizeObserver?.disconnect();
      this.dockResizeObserver = null;
      if (this.dock) this.setDockVisible(false);
      this.info?.removeAttribute('data-sa-known-unavailable');
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.focusReturnFrame);
      this.focusReturnFrame = null;
      this.frame = null;
      this.needsSync = false;
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('sa-inquiry-open');
      if (this.content && this.inquiry && !this.inquiry.contains(this.content)) this.inquiry.append(this.content);
      if (this.inquiry && !this.contains(this.inquiry)) this.append(this.inquiry);
      if (this.productLinks && !this.contains(this.productLinks)) this.append(this.productLinks);
      this.nativeButton = null;
      this.visibilityAnchor = null;
      this.knownUnavailable = false;
      this.info = null;
      this.ready = false;
    }
  }
  customElements.define('snoozair-product-tools', SnoozairProductTools);
}


  } catch(e) { console.error(e); }
})();
})();
